import { BaseCommand } from './baseCommand';
import Element, { ElementType } from '../element';
import store from '@/store';
import { util } from '../util';
import ChangeColorCommand from './changeColorCommand';
import { legs } from '../legs';
import { Product } from '@/store/modules/product';
import ChangeLegsCommand from './changeLegsCommand';
import { handles } from '../handles';
import ChangeHandlesCommand from './changeHandlesCommand';

export default class ResetColorsCommand extends BaseCommand {

    constructor(
        scenePreview: any,
    ) {
        super(scenePreview);
    }

    public execute() {
        this.resetColors();
        this.resetLegs();
        this.resetHandles();
    }

    private get currentProduct(): Product {
        return store.getters.product;
    }

    private resetColors() {
        const elements = this.scenePreview.elements
            .filter((x: Element) => x.isColorable);
        const groupedElements = util.groupBy(elements, 'type');
        const shader = store.getters.furnitureShaders[0];
        Object.entries(groupedElements).forEach((entry: any) => {
            const typedElements = entry[1];
            const changeColorCommand = new ChangeColorCommand(
                this.scenePreview,
                typedElements,
                shader,
                () => store.commit('incrementTasks'),
                () => store.commit('decrementTasks'),
                false,
            );
            this.addCommand(changeColorCommand);
        });
    }

    private resetLegs() {
        const existingLegs = this.scenePreview.elements.find((x: Element) =>
            x.type === ElementType.LEGS);
        if (!existingLegs) { return; }
        const basicLegs = legs.filter((x) =>
            x.type === this.currentProduct.type)[0];
        const changeLegsCommand = new ChangeLegsCommand(
            this.scenePreview,
            basicLegs,
        );
        this.addCommand(changeLegsCommand);
    }

    private resetHandles() {
        const basicHandle = handles[0];
        const changeHandlesCommand = new ChangeHandlesCommand(
            this.scenePreview,
            basicHandle,
        );
        this.addCommand(changeHandlesCommand);
    }
}
